module.exports = __webpack_public_path__ + "static/media/JWLogo.f34ec1d4.png";